import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M0 19.59a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4v-1.87a1.23 1.23 0 1 0-2.45 0v1.87A1.59 1.59 0 0 1 20 21.18H4a1.59 1.59 0 0 1-1.59-1.59v-1.87a1.23 1.23 0 1 0-2.45 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 19.32a2 2 0 0 0 2-2V8.2a.25.25 0 0 1 .21-.2h2.69a1 1 0 0 0 .74-1.62L12.74.7a1 1 0 0 0-1.48 0l-4.9 5.63A1 1 0 0 0 7.1 8h2.69a.25.25 0 0 1 .21.2v9.16a2 2 0 0 0 2 1.96Z"
})), 'UploadBottom');